import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AmplitudeService } from '../../../../shared/services/amplitude.service';

@Component({
  selector: 'cc-empty-numbers',
  templateUrl: './empty-numbers.component.html',
  styleUrls: ['./empty-numbers.component.scss']
})
export class EmptyNumbersComponent implements OnInit {
  @Input() pricingId: number;

  constructor(private location: Location, private amplitudeService: AmplitudeService) {}

  ngOnInit() {
    this.logAmplitude('Init');
  }

  back() {
    this.logAmplitude('Going back');
    this.location.back();
  }

  private logAmplitude(event: string) {
    this.amplitudeService.logEvent(`Panel:Numbers:No numbers for pricing: ${event}`, { pricingId: this.pricingId });
  }
}
